import React from "react";

import fileDownload from "commons/utils/fileDownload";

import useMediaApi from "hooks/api/private/useMediaApi";

export type DownloadMediaHook = (id: string) => void;

function useDownloadMedia(): DownloadMediaHook {
    const { getOne } = useMediaApi();

    const downloadMedia: DownloadMediaHook = React.useCallback(
        (id: string) => {
            const [apiCall] = getOne({ id });

            apiCall.then((response) => {
                fileDownload(
                    response.file_content,
                    response.filename,
                    response.content_type ?? "application/octet-stream"
                );
            });
        },
        [getOne]
    );

    return React.useMemo((): DownloadMediaHook => downloadMedia, [downloadMedia]);
}

export default useDownloadMedia;
